import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`To add a `}<a parentName="p" {...{
          "href": "/api/../api/projects/orders#parcel"
        }}>{`Parcel`}</a>{`, there needs to be at least one `}<a parentName="p" {...{
          "href": "/api/../api/projects/orders#delivery"
        }}>{`Delivery`}</a>{` created before.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"addParcelToDelivery"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`deliveryId`}</inlineCode>{` - String - ID of the `}<a parentName="li" {...{
            "href": "/api/../api/projects/orders#delivery"
          }}>{`Delivery`}</a>{` to which the parcel should be added.`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`measurements`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/projects/orders#parcelmeasurements"
          }}>{`ParcelMeasurements`}</a>{` - Optional`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`trackingData`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/projects/orders#trackingdata"
          }}>{`TrackingData`}</a>{` - Optional`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`items`}</inlineCode>{` - Array of `}<a parentName="li" {...{
            "href": "/api/../api/projects/orders#deliveryitem"
          }}>{`DeliveryItem`}</a>{` - Optional`}</li>
      </ul>
      <p parentName="section">{`This update action produces a `}<a parentName="p" {...{
          "href": "/api/../api/projects/messages#parcel-added-to-delivery"
        }}>{`ParcelAddedToDelivery`}</a>{` Message.`}</p>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      